const ResourceAnalysis = () =>
  import('@/views/main/inspect/resourceAnalysis/ResourceAnalysis.vue')
export default {
  path: '/main/inspect/resourceAnalysis',
  name: 'ResourceAnalysis',
  component: ResourceAnalysis,
  children: []
}
